import { CssColor, CssFont } from '@wix/wix-site-theme-variables';
export { CssColor, CssFont };
export const wixFont = variable => {
  return {
    type: 'static',
    preset: `var(--${variable})`
  };
};
export const wixColor = variable => {
  return {
    type: 'static',
    preset: `var(--${variable})`
  };
};
//# sourceMappingURL=wixBrand.js.map